module.exports = __webpack_public_path__ + "img/A3_HQ01.f5d4acac.jpg";